// extracted by mini-css-extract-plugin
module.exports = {"label":"SeasonCreate_label__3ystv","container":"SeasonCreate_container__3IiRL"};